import { Box, Collapse, Flex, HStack, Text } from '@chakra-ui/react';
import { ChevronRightIcon } from '@chakra-ui/icons';
import { type LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';

const SidebarGroup = ({
  title,
  icon: Icon,
  isOpen,
  isActive,
  onToggle,
  children,
}: {
  title: string;
  icon: LucideIcon;
  // Whether the group is expanded.
  isOpen: boolean;
  // Whether one of the group's sub-items matches the current route.
  isActive: boolean;
  onToggle: () => void;
  children: ReactNode;
}) => {
  const highlight = isActive && !isOpen;

  return (
    <Box width={'100%'}>
      <Flex
        cursor={'pointer'}
        onClick={onToggle}
        alignItems={'center'}
        justifyContent={'space-between'}
        paddingLeft={'14px'}
        paddingRight={'12px'}
        height={'44px'}
        fontWeight={highlight ? 700 : 600}
        fontSize={'15px'}
        color={highlight ? 'white' : 'whiteAlpha.800'}
        bgColor={highlight ? 'whiteAlpha.200' : 'transparent'}
        _hover={{ bgColor: highlight ? 'whiteAlpha.200' : 'whiteAlpha.100', color: 'white' }}
        borderRadius={'10px'}
        transition={'background-color 0.18s ease, color 0.18s ease'}
      >
        <HStack gap={'10px'}>
          <Icon size={18} strokeWidth={highlight ? 2.4 : 2} />
          <Text>{title}</Text>
        </HStack>
        <ChevronRightIcon
          boxSize={5}
          color={highlight ? 'white' : 'whiteAlpha.600'}
          transform={isOpen ? 'rotate(90deg)' : 'rotate(0deg)'}
          transition={'transform 0.18s ease'}
        />
      </Flex>

      <Collapse in={isOpen} animateOpacity>
        {/* Indented children with a vertical tree-guide line */}
        <Box
          marginTop={'2px'}
          marginLeft={'22px'}
          paddingLeft={'10px'}
          borderLeft={'1.5px solid'}
          borderColor={'whiteAlpha.300'}
          display={'flex'}
          flexDirection={'column'}
          gap={'2px'}
        >
          {children}
        </Box>
      </Collapse>
    </Box>
  );
};

export default SidebarGroup;
